export const PROJECT_TYPES = ['Pipeline', 'Fabrication', 'Others'] as const;
export const STATUS_TYPES = ['In Progress', 'Completed', 'On Hold'] as const;
export const PROJECTS_PER_PAGE = 15;

export const STATUS_COLORS = {
  'In Progress': 'text-blueprint-blue bg-[rgba(0,39,63,0.06)]',
  'Completed': 'text-galvanizing-green bg-[rgba(31,154,58,0.08)]',
  'On Hold': 'text-[#B38600] bg-[rgba(230,161,0,0.08)]',
  'default': 'text-heritage-grey bg-[rgba(150,150,150,0.08)]',
} as const;
